import {createSelector} from 'reselect';

const selectState = (state) => state.yapEncrypted;

const makeSelectAssetByAssetId = (assetId) =>
    createSelector(selectState, (state) => state.yapAssets?.find((asset) => asset.assetId === assetId));

const makeSelectAssetByType = (isHolder = false) =>
    createSelector(selectState, (state) => state.yapAssets?.find((asset) => asset.isHolder === isHolder));

const makeSelectAssetIdByType = (isHolder = false) =>
    createSelector(selectState, (state) => state.yapAssets?.find((asset) => asset.isHolder === isHolder)?.assetId);

const makeSelectIsYapSynchronizeDataCollectionInProgress = () =>
    createSelector(selectState, (state) => state.isYapSynchronizeDataCollectionInProgress);

const makeSelectIsYapDataCollectionAllowed = () =>
    createSelector(selectState, (state) => state.isYapDataCollectionAllowed);

const makeSelectIsYapSynchronizeDataCollectionReceived = (isHolder = false) =>
    createSelector(selectState, (state) =>
        isHolder
            ? state.isYapSynchronizeHolderDataCollectionReceived
            : state.isYapSynchronizeDeviceDataCollectionReceived
    );

const makeSelectIsYapDeviceInfoReceived = () => createSelector(selectState, (state) => state.isYapDeviceInfoReceived);

const makeSelectIsYapHolderInfoReceived = () => createSelector(selectState, (state) => state.isYapHolderInfoReceived);

const makeSelectIsYapAutoCleaningInProgress = () =>
    createSelector(selectState, (state) => state.isYapAutoCleaningInProgress);

const makeSelectRequestActionTypeData = (isHolder) =>
    createSelector(selectState, (state) =>
        isHolder ? state.yapHolderRequestActionTypeData : state.yapRequestActionTypeData
    );

const makeSelectIsYapUpdateSettingsInProgress = (isHolder = false) =>
    createSelector(selectState, (state) =>
        isHolder ? state.isYapHolderUpdateSettingsInProgress : state.isYapUpdateSettingsInProgress
    );

const selectIsYapUpdateSettingsInProgress = createSelector(
    selectState,
    (state) => state.isYapHolderUpdateSettingsInProgress || state.isYapUpdateSettingsInProgress
);

const makeSelectYapCancelDataCollectionInProgress = () =>
    createSelector(selectState, (state) => state.isCancelDataCollectionInProgress);

const makeSelectIsYapFirmwareInProgress = () => createSelector(selectState, (state) => state.isYapFirmwareInProgress);

const makeSelectIsOfflineYapFirmwareInProgress = () =>
    createSelector(selectState, (state) => state.isOfflineYapFirmwareInProgress);

const makeSelectIsDeviceSyncInProgress = (isHolder) =>
    createSelector(selectState, (state) => (isHolder ? state.isYapHolderSyncInProgress : state.isYapSyncInProgress));

const makeSelectIsYapDeviceConnected = () => createSelector(selectState, (state) => state.isYapDeviceConnected);

const makeSelectIsYapHolderConnected = () => createSelector(selectState, (state) => state.isYapHolderConnected);

const makeSelectYapLastRequestId = (isHolder = false) =>
    createSelector(selectState, (state) => (isHolder ? state.lastHolderRequestId : state.lastRequestId));

const makeSelectSyncLastRequestId = (isHolder) =>
    createSelector(selectState, (state) => (isHolder ? state.lastHolderSyncRequestId : state.lastSyncRequestId));

const makeSelectIsYapForceCheckRequest = (isHolder) =>
    createSelector(selectState, (state) =>
        isHolder ? state.isYapHolderForceCheckRequest : state.isYapForceCheckRequest
    );

const makeSelectCmMessageData = () =>
    createSelector(selectState, (state) => {
        return {cmToken: state.cmToken, cmRequestId: state.cmRequestId};
    });

const selectDeviceAsset = makeSelectAssetByType();
const selectHolderAsset = makeSelectAssetByType(true);

const makeSelectIsHolderByAssetId = (assetId) =>
    createSelector(makeSelectAssetByAssetId(assetId), (asset) => {
        const {isHolder} = asset || {};

        return isHolder;
    });

const makeSelectYapLastDataCollectionTime = () =>
    createSelector(selectState, (state) => state.lastDataCollectionTimes?.find((time) => time?.isValid)?.time);

export {
    makeSelectAssetByAssetId,
    makeSelectAssetByType,
    makeSelectAssetIdByType,
    makeSelectCmMessageData,
    makeSelectIsDeviceSyncInProgress,
    makeSelectIsHolderByAssetId,
    makeSelectIsOfflineYapFirmwareInProgress,
    makeSelectIsYapAutoCleaningInProgress,
    makeSelectIsYapDataCollectionAllowed,
    makeSelectIsYapDeviceConnected,
    makeSelectIsYapDeviceInfoReceived,
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapForceCheckRequest,
    makeSelectIsYapHolderConnected,
    makeSelectIsYapHolderInfoReceived,
    makeSelectIsYapSynchronizeDataCollectionInProgress,
    makeSelectIsYapSynchronizeDataCollectionReceived,
    makeSelectIsYapUpdateSettingsInProgress,
    makeSelectRequestActionTypeData,
    makeSelectSyncLastRequestId,
    makeSelectYapCancelDataCollectionInProgress,
    makeSelectYapLastDataCollectionTime,
    makeSelectYapLastRequestId,
    selectDeviceAsset,
    selectHolderAsset,
    selectIsYapUpdateSettingsInProgress,
};
